import { useRef, useState } from 'react';
import { validateFile } from './utils';
import { IMPORT_STATUS } from './constants';

export const useImportProperties = () => {
  const [uploadedFile, setUploadFile] = useState(null);
  const [invalidFileMessage, setInvalidFileMessage] = useState('');
  const [importStatus, setImportStatus] = useState(IMPORT_STATUS.IDLE);

  const fileInputRef = useRef();

  const { name: fileName, size: fileSize } = uploadedFile || {};

  const handleDropTargetClick = () => {
    setInvalidFileMessage('');
    fileInputRef.current.click();
  };

  const handleImportProperties = async () => {
    const data = new FormData();
    data.append('properties-import', uploadedFile, 'properties-import.csv');
    setImportStatus(IMPORT_STATUS.PROCESSING);
    // TODO: Replace with actual import logic
    setTimeout(() => {
      setImportStatus(IMPORT_STATUS.SUCCESS);
    }, 3000);
  };

  const handleFile = ([file] = [{}], e) => {
    e?.preventDefault();
    const validationErrorMessage = validateFile(file);
    if (validationErrorMessage) {
      setInvalidFileMessage(validationErrorMessage);
      return;
    }
    setUploadFile(file);
    setImportStatus(IMPORT_STATUS.READY);
  };

  const clearErrorMessage = () => {
    setInvalidFileMessage('');
  };

  const removeUploadedFile = () => {
    setUploadFile(null);
    setImportStatus(IMPORT_STATUS.IDLE);
  };

  return {
    clearErrorMessage,
    fileInputRef,
    fileName,
    fileSize,
    importStatus,
    invalidFileMessage,
    handleDropTargetClick,
    handleImportProperties,
    handleFile,
    removeUploadedFile,
  };
};
